import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import {
  ReduxInput,
  ReduxSelect,
  ReduxSwitch,
  WeekDaysSelect,
  ReduxDatePicker
} from 'components/FormElements/ReduxForm'
import RecurrenceEnds from './components/RecurrenceEnds'
// constants
import { Forms } from 'constants/forms'
import { CAPTURE_TYPE_OPTIONS, EACH_PERIOD_ENDS_TYPE_OPTIONS, REPEAT_OPTIONS, REPEAT_VALUES } from 'constants/index'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// views
import { Header } from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/DetailsForm/components/view'
import { ButtonsContainer, EachPeriodEndsTypeContainer, FieldsContainer, Form, ResultDurationContainer } from './views'
// themes
import { CloseIcon } from 'components/UI/Icons'
// utils
import { greaterThanZero, positive, required } from 'utils/index'

interface Props {
  isRisk?: boolean
  hideModal: () => void
  isLoading: boolean
  repeatEveryType: string
}

const RecurrenceForm: React.FC<InjectedFormProps<any, Props> & Props> = ({
  form,
  isRisk,
  hideModal,
  isLoading,
  handleSubmit,
  repeatEveryType
}) => {
  return (
    <Form component={'form'} onSubmit={handleSubmit} width={'xs'}>
      <Header>
        <span>{`${isRisk ? 'Form' : 'Indicator'} Recurrence`}</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <FieldsContainer>
        {isRisk && <ReduxSwitch label='Active' name='active' />}
        <ReduxInput
          type={'number'}
          label={'Repeat'}
          name={'repeatEveryValue'}
          validate={[positive, greaterThanZero, required]}
        />
        <ReduxSelect name={'repeatEveryType'} label={'Every'} options={REPEAT_OPTIONS} validate={[required]} />
        {repeatEveryType === REPEAT_VALUES.WEEKLY && <WeekDaysSelect name={'days'} validate={[required]} />}
        {repeatEveryType === REPEAT_VALUES.MONTHLY && (
          <EachPeriodEndsTypeContainer>
            <ReduxSelect
              validate={[required]}
              name={'eachPeriodEndsType'}
              label={'Each period ends on'}
              options={EACH_PERIOD_ENDS_TYPE_OPTIONS}
            />
          </EachPeriodEndsTypeContainer>
        )}
        <ReduxDatePicker label={'Start of first period'} name={'firstPeriodStartsAt'} validate={[required]} />
        <ReduxDatePicker label={'End of first period'} name={'firstPeriodEndsAt'} disabled />
      </FieldsContainer>
      {!isRisk && (
        <ResultDurationContainer>
          <span>How long after the end of the first period should the first result be captured?</span>
          <ReduxInput name={'captureDuration'} type={'number'} validate={[positive, required]} />
          <ReduxSelect name={'captureType'} options={CAPTURE_TYPE_OPTIONS} validate={[required]} />
        </ResultDurationContainer>
      )}

      <RecurrenceEnds form={form} />

      <ButtonsContainer>
        <Button type={'submit'} isLoading={isLoading} layout={BUTTON_LAYOUTS.PURPLE} shadowLess>
          Save
        </Button>
        <Button type={'button'} onClick={hideModal} layout={BUTTON_LAYOUTS.PURPLE_INVERTED} shadowLess>
          Cancel
        </Button>
      </ButtonsContainer>
    </Form>
  )
}

export default reduxForm<any, Props>({ form: Forms.KPI_RECURRENCE_FORM, enableReinitialize: true })(RecurrenceForm)
